import React, { useState } from 'react';
import { Modal, Input, Select, Button } from '@/components/ui';
import { FormGroup, FormLabel } from '@/components/ui/Form';
import { roleConfigMap } from '@/utils/role';

interface InviteMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
  onInvite: (email: string, roleCode: string) => Promise<void>;
}

export function InviteMemberModal({ isOpen, onClose, onInvite }: InviteMemberModalProps) {
  const [email, setEmail] = useState('');
  const [roleCode, setRoleCode] = useState('staff');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await onInvite(email, roleCode);
      onClose();
      setEmail('');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Mời thành viên mới" size="md">
      <form onSubmit={handleSubmit} className="space-y-4">
        <FormGroup>
          <FormLabel required>Địa chỉ Email</FormLabel>
          <Input 
            type="email" 
            value={email} 
            onChange={e => setEmail(e.target.value)}
            placeholder="nhanvien@congty.com"
            required
          />
        </FormGroup>
        
        <FormGroup>
          <FormLabel required>Vai trò hệ thống</FormLabel>
          <Select
            value={roleCode}
            onChange={e => setRoleCode(e.target.value)}
            options={Object.entries(roleConfigMap)
              .filter(([code]) => code !== 'super_admin')
              .map(([code, config]) => ({
                value: code,
                label: config.label
              }))
            }
          />
          <p className="text-[10px] text-slate-400 mt-2 px-1">
            * Vai trò này quyết định quyền truy cập các module trong hệ thống.
          </p>
        </FormGroup>

        <div className="flex justify-end gap-3 pt-6 border-t border-slate-100">
          <Button variant="outline" type="button" onClick={onClose}>Hủy</Button>
          <Button variant="primary" type="submit" isLoading={isSubmitting} icon="ri-send-plane-fill">
            Gửi lời mời
          </Button>
        </div>
      </form>
    </Modal>
  );
}
